import type { RouteSitemapConfig } from './sitemap.config';

export const pathnames = {
  HOME: '/',
  LITEPAPER: '/litepaper',
  VALIDATE: '/validate',
  DELEGATE: '/delegate',
  STAKE: '/co-stake',
  UTILITY_AND_ECONOMICS: '/utility-and-economics',
  MEDIA_KIT: '/media-kit',
  COMMUNITY: '/community',
  GRANTS: '/grants',
  GRANT_DETAILS: '/grant-details/:id',
  FOUNDATION_DELEGATIONS: '/foundation-delegations',
  PROTOCOL_TREASURY: '/protocol-treasury',
  LIQUIDITY_MINING: '/liquidity-mining',
  RWA: '/rwa',
  ABOUT_US: '/about-us',
  TEAM: '/team',
  DOMAINS: '/domains',
  WALLET_TEASER: '/wallet',
  TESTNET: '/testnet',
} as const;

export interface RouteManifestEntry {
  exact?: boolean;
  path: string;
  sitemap?: RouteSitemapConfig;
}

export const routeManifest: RouteManifestEntry[] = [
  {
    path: pathnames.HOME,
    exact: true,
    sitemap: {
      changefreq: 'daily',
      priority: 1,
    },
  },
  {
    path: pathnames.LITEPAPER,
    sitemap: {
      changefreq: 'yearly',
      priority: 0.7,
    },
  },
  {
    path: pathnames.TESTNET,
    sitemap: {
      changefreq: 'weekly',
      priority: 0.9,
    },
  },
  {
    path: pathnames.VALIDATE,
    sitemap: {
      changefreq: 'weekly',
      priority: 0.8,
    },
  },
  {
    path: pathnames.DELEGATE,
    sitemap: {
      changefreq: 'weekly',
      priority: 0.8,
    },
  },
  {
    path: pathnames.STAKE,
    sitemap: {
      changefreq: 'weekly',
      priority: 0.8,
    },
  },
  {
    path: pathnames.UTILITY_AND_ECONOMICS,
    sitemap: {
      priority: 0.7,
    },
  },
  {
    path: pathnames.MEDIA_KIT,
    sitemap: {
      priority: 0.6,
    },
  },
  {
    path: pathnames.COMMUNITY,
    sitemap: {
      changefreq: 'weekly',
      priority: 0.7,
    },
  },
  {
    path: pathnames.TEAM,
    sitemap: {
      priority: 0.6,
    },
  },
  {
    path: pathnames.FOUNDATION_DELEGATIONS,
    sitemap: {
      changefreq: 'weekly',
      priority: 0.8,
    },
  },
  {
    path: pathnames.RWA,
    sitemap: {
      changefreq: 'weekly',
      priority: 0.8,
    },
  },
  {
    path: pathnames.PROTOCOL_TREASURY,
    sitemap: {
      changefreq: 'weekly',
      priority: 0.8,
    },
  },
  {
    path: pathnames.LIQUIDITY_MINING,
    sitemap: {
      changefreq: 'weekly',
      priority: 0.8,
    },
  },
  {
    path: pathnames.GRANTS,
    sitemap: {
      changefreq: 'weekly',
      priority: 0.8,
    },
  },
  {
    path: pathnames.GRANT_DETAILS,
    sitemap: false,
  },
  {
    path: pathnames.DOMAINS,
    sitemap: {
      priority: 0.7,
    },
  },
  {
    path: pathnames.ABOUT_US,
    sitemap: {
      priority: 0.6,
    },
  },
  {
    path: pathnames.WALLET_TEASER,
    sitemap: {
      priority: 0.7,
    },
  },
];
